export const nextQuestion = (question, reponse) => ({
  type: 'NEXT_QUESTION',
  payload: {
    question,
    reponse
  }
});

export const resetQuiz = () => ({
  type: 'EXIT_GAME'
});
